import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

export interface ClientGroupsState {
  activeClientGroupId: string | null;
}

const initialState: ClientGroupsState = {
  activeClientGroupId: null,
};

const clientGroupsSlice = createSlice({
  name: 'clientGroups',
  initialState,
  reducers: {
    setActiveClientGroupId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeClientGroupId = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveClientGroupId = (state: RootState) => state.clientGroups.activeClientGroupId;

export const { setActiveClientGroupId } = clientGroupsSlice.actions;

const clientGroupsReducer = clientGroupsSlice.reducer;

export default clientGroupsReducer;
